export default __webpack_public_path__ + "static/sidebar-light-4a1aec5a231ccee574adf09ad66ab2b0d54d0956a04e297aa6fa4d6e02c38a67.png";